__webpack_require__.p = "https://bmidxblithuaniaplprod.netlify.app/";